<template>
    <div>
        <div class="mt-2">
            <strong>Colonnes de tri</strong>
            <small class="text-muted d-block mb-1">Les lignes sont triées successivement selon chaque colonne (ordre du tableau)</small>
            <b-table-simple small bordered class="mt-1">
                <b-thead>
                    <b-tr>
                        <b-th>Colonne</b-th>
                        <b-th>Sens</b-th>
                        <b-th>Nombres</b-th>
                        <b-th></b-th>
                    </b-tr>
                </b-thead>
                <b-tbody>
                    <b-tr v-for="(row, idx) in columns" :key="'sort' + idx">
                        <b-td>
                            <b-input :list="'sortcol' + id" v-model="row.column" size="sm" />
                            <datalist :id="'sortcol' + id">
                                <option v-for="(c, ci) in columns_data" :key="'sc' + ci">{{ c }}</option>
                            </datalist>
                        </b-td>
                        <b-td>
                            <b-select v-model="row.order" size="sm" :options="[
                                { text: 'Croissant', value: 'croissant' },
                                { text: 'Décroissant', value: 'décroissant' }
                            ]" />
                        </b-td>
                        <b-td class="text-center">
                            <b-checkbox v-model="row.number" />
                        </b-td>
                        <b-td>
                            <b-button size="sm" variant="danger" @click="columns.splice(idx, 1)">✕</b-button>
                        </b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>
            <b-button size="sm" @click="add_column_row">+ Ajouter une colonne</b-button>
        </div>
    </div>
</template>

<script>
    import uniqueId from "lodash.uniqueid";

    export default {
        name: "sort_step",
        props: {
            data: { default: () => [] },
            files: { default: () => [] },
            client: { default: null },
            size: { default: 1000 },
            step_position: { default: 0 }
        },
        watch: {
            data: {
                deep: true,
                immediate: true,
                handler() {
                    if (this.data.length > 0) {
                        this.columns_data = Object.keys(this.data[0]);
                    }
                }
            }
        },
        data() {
            return {
                id: uniqueId(""),
                columns_data: [],
                columns: []
            };
        },
        methods: {
            add_column_row() {
                this.columns.push({ column: "", order: "croissant", number: false });
            },
            save() {
                return {
                    columns: this.columns
                };
            },
            async load(data) {
                if (!data) data = {};
                this.columns = Array.isArray(data.columns) ? data.columns.map(c => ({
                    column: c.column || "",
                    order: c.order || "croissant",
                    number: !!c.number
                })) : [];
            }
        }
    };
</script>

<style scoped>
</style>
